import { ChangeEvent, useState } from 'react'
import { isEmpty } from 'lodash'

import CheckAccordionItem from 'components/CheckAccordionItem'
import Checkbox from 'components/Checkbox'

import { TOptionSelectDropdown } from 'types/components'

type TAdditionalOption = { name: string; uuid: string; isDropdown: boolean }

type TReturnValue = { name: string; option: string; isActiveCheckAccordion: boolean }

type TProps = {
  label: string
  selectOptions: TOptionSelectDropdown[]
  defaultSelectOption: TOptionSelectDropdown
  onChange: (value: TReturnValue) => TReturnValue
  checked: boolean
  additionalAccordionOptions?: TAdditionalOption[]
  disabledCheckbox?: boolean
  disabledDropdown?: boolean
  isDropdown?: boolean
}

const CheckAccordion = ({
  label,
  checked,
  selectOptions,
  defaultSelectOption,
  onChange,
  additionalAccordionOptions = [],
  disabledCheckbox,
  disabledDropdown,
  isDropdown,
}: TProps) => {
  const [isActiveCheckbox, setIsActiveCheckbox] = useState(checked)
  const [selectOption, setSelectOption] = useState({ name: label, option: 'VIEW' })

  const isAdditionalAccordionOptions = isActiveCheckbox && !isEmpty(additionalAccordionOptions)

  const onChangeCheckBox = (event: ChangeEvent<HTMLInputElement>) => {
    setIsActiveCheckbox(event.target.checked)
    onChange({ ...selectOption, isActiveCheckAccordion: event.target.checked })
  }

  const onChangeSelectOption = (value: TOptionSelectDropdown) => {
    onChange({ name: label, option: value.name, isActiveCheckAccordion: isActiveCheckbox })
    setSelectOption({ name: label, option: value.name })
  }

  return (
    <div className="check-accordion">
      <div className="check-accordion__row">
        <div className="check-accordion__checkbox">
          <Checkbox
            onChange={onChangeCheckBox}
            checked={isActiveCheckbox}
            disabled={disabledCheckbox}
            name={label}
          />
        </div>
        <CheckAccordionItem
          label={label}
          selectOptions={selectOptions}
          defaultSelectOption={defaultSelectOption}
          onChangeSelectOption={onChangeSelectOption}
          isActive={isActiveCheckbox}
          disabledDropdown={disabledDropdown}
          disabledLabel={disabledCheckbox}
          isDropdown={isDropdown}
          isHighlited={isActiveCheckbox}
        />
      </div>
      {isAdditionalAccordionOptions &&
        additionalAccordionOptions?.map(({ name, uuid, isDropdown }) => (
          <div className="check-accordion__row" key={uuid}>
            <CheckAccordionItem
              label={name}
              selectOptions={selectOptions}
              defaultSelectOption={defaultSelectOption}
              onChangeSelectOption={onChangeSelectOption}
              isHighlited={false}
              disabledDropdown={disabledDropdown}
              disabledLabel={disabledCheckbox}
              isDropdown={isDropdown}
            />
          </div>
        ))}
    </div>
  )
}

export default CheckAccordion
